import { datadogRum } from '@datadog/browser-rum'

/**
 * Track errors in datadog
 * @param pageName
 * @param error
 * @param extraParams
 * @param source
 */
export const trackInDatadog = (actionName, error, extraParams, source = 'network') => {
  datadogRum.addError(
    error,
    {
      actionName: actionName,
      error: error.response || error.message,
      ...extraParams
    },
    source
  )
}
